import {
  initTracerError,
  initTracerErrorAsyncStack,
  initTracerErrorUploader,
  initTracerSessionUploader,
  ITracerUploaderConfig,
} from "@apptracer/sdk";

const appToken = import.meta.env.VITE_APPTRACER_API_TOKEN as string | undefined;

const tracerConfig: ITracerUploaderConfig = {
  appToken: appToken ?? "",
  versionName: `builddocs-v2-${import.meta.env.MODE}`,
  environment: import.meta.env.MODE,
};

export const tracerError = initTracerError({
  handleOtherErrorDataType: true,
  stringifyErrorDataObject: true,
});

if (appToken) {
  try {
    initTracerErrorUploader(tracerConfig);
    initTracerSessionUploader(tracerConfig);
  } catch {
    // Uploaders are optional – a missing or misconfigured plugin must not crash the app.
  }
}

try {
  initTracerErrorAsyncStack();
} catch {
  // Async stack enrichment is optional – must not crash the app if plugin is unavailable.
}
